import { FC } from 'react';
import { DeletePvaFunction } from './delete-pva-function';
import { EnableSkillFunction } from './enable-skill-function';
import { ReadAlexaFunction } from './read-alexa-function';
import {
  buildGetDeviceDetailsRequest,
  buildGetUnitInfoRequest,
} from './request-builders';
import { AlexaDeviceWithMeta } from './types';

type AlexaFunctionsSectionProps = {
  device: AlexaDeviceWithMeta;
};

export const AlexaFunctionsSection: FC<AlexaFunctionsSectionProps> = ({
  device,
}) => {
  const roomEndpoint = device.meta.roomEndpoint;
  const knownSkills = (device.state?.skills ?? [])
    .filter((skill) => !skill.actualEnabled)
    .map(({ skillId, skillName, declaredStage }) => ({
      skillId,
      skillName,
      declaredStage,
    }));

  return (
    <section
      aria-labelledby="alexa-functions-title"
      className="mt-8 rounded-lg border border-gray-300 bg-gray-100 p-4"
    >
      <div className="border-b border-gray-300 pb-3">
        <h2 className="text-base font-medium" id="alexa-functions-title">
          Alexa functions
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Platform Admin tools for this Alexa device.
        </p>
      </div>
      <div className="mt-4 flex flex-col gap-4">
        <ReadAlexaFunction
          buttonLabel="Get details"
          description="Fetch the current Amazon device record using this device's stored endpoint."
          request={buildGetDeviceDetailsRequest(device.id)}
          title="Get details from DSN"
        />
        <ReadAlexaFunction
          buttonLabel="Get unit info"
          description="Fetch the Amazon Smart Properties room associated with this device."
          disabledReason={
            roomEndpoint ? undefined : 'This Alexa device has no room endpoint.'
          }
          request={
            roomEndpoint ? buildGetUnitInfoRequest(device.id) : undefined
          }
          title="Get unit info"
        />
        <DeletePvaFunction deviceId={device.id} roomEndpoint={roomEndpoint} />
        <EnableSkillFunction
          deviceId={device.id}
          roomEndpoint={roomEndpoint}
          skills={knownSkills}
        />
      </div>
    </section>
  );
};
